import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormInput,
} from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import firebase from "../../fire";
import { InputLabel, MenuItem, FormControl, Select } from "@material-ui/core";
import { useLocation, useParams } from "react-router";
// import MenuItem from "@material-ui/MenuItem";
// import FormControl from "@material-ui/FormControl";
// import Select from "@material-ui/Select";

export default function EditAds() {
  const { data } = useLocation();

  const [vidtitle, setVidTitle] = useState(data?.video?.name);
  const [file, setFile] = useState("");
  const [reward, setReward] = useState("");
  const [totalReward, settotalReward] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [age, setAge] = React.useState(data?.video?.video);
  const [selectedVideo, setselectedVideo] = React.useState("");
  useEffect(() => {
    setLoading(true);
    getVideos().then(function (result) {
      result.forEach((data) => {
        setLoading(false);
        setVideos((previous) => [...previous, data]);
      });
    });
  }, []);

  async function getVideos() {
    let arrData = [];
    const db = firebase.firestore();
    const snapshot = await db.collection("videos").get();
    snapshot.docs.forEach((item) => {
      const itemData = item.data();
      arrData.push({ ...itemData, _id: item.ref.id });
    });
    return arrData;
  }
  const handleSubmit = (evt) => {
    evt.preventDefault();
    setLoading(true);
    console.log("ID=>", data?.video?._id);
    const db = firebase.firestore();
    const userRef = db
      .collection("ads")
      .doc(data?.video?._id)
      .update({
        name: vidtitle,
        video: age,
      })
      .then((res) => {
        setLoading(false);
        Swal.fire("AD", "Tv Ad Updated Successfully", "success");
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  const handleChange = (event) => {
    console.log(event.target.value._id);
    let arr = age ? age : [];
    console.log("Arr Data Add Check", arr);
    if (arr?.length > 0) {
      if (arr.find((x) => x?._id !== event.target.value._id)) {
        console.log("Arr==>", age, event.target.value, [
          ...age,
          event.target.value,
        ]);
        setAge([...age, event.target.value]);
      }
    } else {
      setAge([...age, event.target.value]);
    }
  };

  const [videos, setVideos] = useState([]);
  const removeRefer = (id) => {
    let data = age;
    data = age.filter((x) => x?._id !== id);
    console.log("Arr Data Remove ", data.length > 0);
    setAge(data ? data : "");
  };

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <Row noGutters className="page-header py-4">
        <PageTitle
          sm="4"
          title="Edit TV AD"
          subtitle="TV ADs "
          className="text-sm-left"
        />
      </Row>

      <Row>
        <Col lg="9" md="12">
          <Card small className="mb-3">
            <CardBody>
              <form onSubmit={handleSubmit}>
                <div class="form-group">
                  <label for="exampleInputFullname"> AD Title </label>
                  <input
                    type="text"
                    value={vidtitle}
                    onChange={(e) => setVidTitle(e.target.value)}
                    name="startDate"
                    class="form-control"
                    id="exampleInputFullname"
                    aria-describedby="fullnameHelp"
                    placeholder="Enter Ad Title "
                  />
                </div>

                <div class="form-group">
                  <label for="video">AD Video</label>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={age}
                    label="Age"
                    onChange={handleChange}
                    placeholder="Select Video to Play Ad"
                    fullWidth
                  >
                    {Array.isArray(videos) && videos?.length > 0
                      ? videos.map((data, id) => (
                          <MenuItem value={data}>{data?.name}</MenuItem>
                        ))
                      : null}
                  </Select>
                </div>
                <div className="d-flex justify-content-center">
                  {console.log("UI RE RENDER")}
                  {Array.isArray(age) && age?.length > 0
                    ? age.map((data, id) => (
                        <div
                          style={{
                            backgroundColor: "#3d5170",
                            width: 200,
                            textAlign: "center",
                            padding: 10,
                            borderRadius: 25,
                            color: "#ffff",
                            margin: 1,
                            cursor: "pointer",
                          }}
                          onClick={() => removeRefer(data?._id)}
                        >
                          {data?.name}
                        </div>
                      ))
                    : null}
                </div>

                {/* <FormControl>
                  <InputLabel id="demo-simple-select-label">Age</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={age}
                    label="Age"
                    onChange={handleChange}
                  >
                    <MenuItem value={10}>Ten</MenuItem>
                    <MenuItem value={20}>Twenty</MenuItem>
                    <MenuItem value={30}>Thirty</MenuItem>
                  </Select>
                </FormControl> */}

                <button
                  disabled={isLoading}
                  type="submit"
                  class="btn btn-primary"
                >
                  {isLoading && <i className="fa fa-refresh fa-spin mr-1"></i>}
                  Update
                </button>
              </form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
